const ApproveRequestButton = ({ onClicked }) => {
  return (
    <div
      onClick={onClicked}
      className="cursor-pointer w-[180px] h-[32px] bg-blueColor rounded-[8px] flex items-center justify-center font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] text-white"
    >
      APPROVE REQUEST
    </div>
  );
};

export default ApproveRequestButton;
